module.exports = __webpack_public_path__ + "assets/img/per-7939e1b8.png";